import React from 'react';
import { formatNumber } from '../../../ui';

/**
 * One number with a label. Put several inside <div className="adm-stats">.
 *
 * tone: 'success' | 'warning' | 'danger' colours the value; hint is a small line below it.
 * `color` is accepted for older callers but ignored, so every card stays on the site palette.
 */
const StatCard = ({ title, value, prefix, suffix, icon, hint, trend, tone, loading = false }) => {
  const shown = typeof value === 'number' ? formatNumber(value) : value ?? '—';
  const note = hint ?? trend;

  return (
    <div className="adm-stat" data-tone={tone}>
      <div className="adm-stat__label">
        {icon}
        <span>{title}</span>
      </div>
      {loading ? (
        <div className="pk-skel adm-stat__skel" aria-label="Loading" />
      ) : (
        <div className="adm-stat__value">
          {prefix}
          {shown}
          {suffix}
        </div>
      )}
      {note && !loading && <div className="adm-stat__hint">{note}</div>}
    </div>
  );
};

export default StatCard;
